import React from 'react';
import localStorage from '../utils/local-storage';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {setAdmin} from '../admin/actions';

class LoginCallback extends React.Component {

  constructor(props) {
    super(props);
    const {match: {params: {jwtToken}}} = props;
    localStorage.setItem('jwt', jwtToken);
    props.setAdmin(!!jwtToken);
    props.history.push('/');
  }

  render() {
    return null;
  }
}

LoginCallback.propTypes = {
  setAdmin: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      jwtToken: PropTypes.string.isRequired
    })
  }),
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  })
};

const mapDispatchToProps = dispatch => {
  return {
    setAdmin: bool => dispatch(setAdmin(bool))
  };
};

const mapStateToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(LoginCallback);



// WEBPACK FOOTER //
// ./src/login-callback/index.js